import en from './en.json';
import de from './de.json';

const translations = { en, de };

export const SUPPORTED_LANGUAGES = [
  { code: 'en', label: 'EN', name: 'English' },
  { code: 'de', label: 'DE', name: 'Deutsch' },
];

export const DEFAULT_LANGUAGE = 'en';

/**
 * Translate a key with optional parameter interpolation.
 * Fallback chain: requested lang → en → defaultStr → key name.
 *
 * Two call signatures supported:
 *   translate(lang, key, params)                    — params: { foo, defaultValue }
 *   translate(lang, key, defaultStr, params)        — i18next style; defaultStr used
 *                                                     when key missing in both dicts
 *
 * Interpolation: {{name}} and {name} are both replaced with params.name.
 */
export function translate(lang, key, defaultOrParams, paramsArg) {
  // Normalize args → defaultStr + params
  let defaultStr;
  let params;
  if (typeof defaultOrParams === 'string') {
    defaultStr = defaultOrParams;
    params = paramsArg;
  } else {
    params = defaultOrParams;
    if (params && typeof params === 'object' && params.defaultValue !== undefined) {
      defaultStr = String(params.defaultValue);
    }
  }

  const dict = translations[lang] || translations.en;
  let str = dict[key];
  if (str === undefined) str = translations.en[key];
  if (str === undefined) str = defaultStr;
  if (str === undefined) return key;

  if (params && typeof params === 'object') {
    Object.keys(params).forEach((k) => {
      if (k === 'defaultValue') return;
      str = str.replace(new RegExp(`\\{\\{${k}\\}\\}|\\{${k}\\}`, 'g'), String(params[k]));
    });
  }
  return str;
}
